export const CREATE_REVIEW = 'CREATE_REVIEW';
export const EDIT_REVIEW = 'EDIT_REVIEW';
export const DELETE_REVIEW = 'DELETE_REVIEW';
export const CREATE_REVIEW_SUCCESS = 'CREATE_REVIEW_SUCCESS';
export const EDIT_REVIEW_SUCCESS = 'EDIT_REVIEW_SUCCESS';
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS';

export const OPEN_REVIEW_DIALOG = 'OPEN_REVIEW_DIALOG';
export const CLOSE_REVIEW_DIALOG = 'CLOSE_REVIEW_DIALOG';

export const REVIEW_REQUEST_ERROR = 'REVIEW_REQUEST_ERROR';

export const REPORT_REVIEW = 'REPORT_REVIEW';
export const REPORT_REVIEW_SUCCESS = 'REPORT_REVIEW_SUCCESS';
export const REPORT_REVIEW_FAILED = 'REPORT_REVIEW_FAILED';

export const LIKE_REVIEW_TOGGLE = 'LIKE_REVIEW_TOGGLE';
export const LIKE_REVIEW_SUCCESS = 'LIKE_REVIEW_SUCCESS';
export const LIKE_REVIEW_FAILED = 'LIKE_REVIEW_FAILED';

export const CREATE_SHOP_REVIEW = 'CREATE_SHOP_REVIEW';
export const CREATE_SHOP_REVIEW_SUCCESS = 'CREATE_SHOP_REVIEW_SUCCESS';
export const EDIT_SHOP_REVIEW = 'EDIT_SHOP_REVIEW';
export const EDIT_SHOP_REVIEW_SUCCESS = 'EDIT_SHOP_REVIEW_SUCCESS';
export const DELETE_SHOP_REVIEW = 'DELETE_SHOP_REVIEW';
export const DELETE_SHOP_REVIEW_SUCCESS = 'DELETE_SHOP_REVIEW_SUCCESS';
export const HIDE_SHOP_REVIEW_THANK_YOU = 'HIDE_SHOP_REVIEW_THANK_YOU';

export const UPDATE_REVIEW_SUMMARY = 'UPDATE_REVIEW_SUMMARY';
export const UPDATE_REVIEW_DATA = 'UPDATE_REVIEW_DATA';

export const SAVE_REVIEW_DRAFT = 'SAVE_REVIEW_DRAFT';

export const createReview = ({
  belongsToId,
  rating,
  reviewType,
  reviewText,
  purchaseDate,
  displayName,
}) => ({
  type: CREATE_REVIEW,
  belongsToId,
  rating,
  reviewType,
  reviewText,
  purchaseDate,
  displayName,
});

export const createShopReview = ({
  belongsToId,
  belongsToName,
  rating,
  reviewText,
  purchaseDate,
  answers,
  email,
  displayName,
}) => ({
  type: CREATE_SHOP_REVIEW,
  reviewType: 'STORE',
  belongsToId,
  belongsToName,
  rating,
  reviewText,
  purchaseDate,
  answers,
  email,
  displayName,
});

export const createShopReviewSuccess = ({ shopId }) => ({
  type: CREATE_SHOP_REVIEW_SUCCESS,
  shopId,
});

export const hideShopReviewThankYouDialog = () => ({
  type: HIDE_SHOP_REVIEW_THANK_YOU,
});

export const editReview = ({
  reviewId,
  belongsToId,
  reviewType,
  rating,
  reviewText,
  purchaseDate,
  location,
}) => ({
  type: EDIT_REVIEW,
  reviewId,
  belongsToId,
  reviewType,
  rating,
  reviewText,
  purchaseDate,
  location,
});

export const editShopReview = ({
  reviewId,
  belongsToId,
  belongsToName,
  rating,
  reviewText,
  purchaseDate,
  answers,
  token,
  location,
}) => ({
  type: EDIT_SHOP_REVIEW,
  reviewType: 'STORE',
  reviewId,
  belongsToId,
  belongsToName,
  rating,
  reviewText,
  purchaseDate,
  answers,
  token,
  location,
});

export const editShopReviewSuccess = ({ shopId, location }) => ({
  type: EDIT_SHOP_REVIEW_SUCCESS,
  shopId,
  location,
});

export const deleteReview = ({
  reviewId,
  belongsToId,
  reviewType,
  location,
}) => ({
  type: DELETE_REVIEW,
  reviewId,
  reviewType,
  belongsToId,
  location,
});

export const deleteShopReview = ({
  reviewId,
  token,
  shopId,
  shopName,
  location,
}) => ({
  type: DELETE_SHOP_REVIEW,
  reviewId,
  token,
  shopId,
  shopName,
  location,
});

export const deleteShopReviewSuccess = ({ shopId, location }) => ({
  type: DELETE_SHOP_REVIEW_SUCCESS,
  shopId,
  location,
});

export const createReviewSuccess = ({ productId }) => ({
  type: CREATE_REVIEW_SUCCESS,
  productId,
});

export const editReviewSuccess = ({ productId, location }) => ({
  type: EDIT_REVIEW_SUCCESS,
  productId,
  location,
});

export const deleteReviewSuccess = ({ productId, location }) => ({
  type: DELETE_REVIEW_SUCCESS,
  productId,
  location,
});

export const updateReviewSummary = summary => ({
  type: UPDATE_REVIEW_SUMMARY,
  summary,
});

export const updateShopReviewData = ({
  shopId,
  productId,
  nodes,
  myReview,
}) => ({
  type: UPDATE_REVIEW_DATA,
  shopId,
  productId,
  nodes,
  myReview,
});

export const openReviewDialog = uid => ({
  type: OPEN_REVIEW_DIALOG,
  uid,
});

export const closeReviewDialog = () => ({
  type: CLOSE_REVIEW_DIALOG,
});

export const reviewRequestError = errorCode => ({
  type: REVIEW_REQUEST_ERROR,
  errorCode,
});

export const reportReview = (reviewId, message, email) => ({
  type: REPORT_REVIEW,
  reviewId,
  message,
  email,
});

export const reportReviewSuccess = () => ({ type: REPORT_REVIEW_SUCCESS });

export const reportReviewFailed = message => ({
  type: REPORT_REVIEW_FAILED,
  message,
});

export const likeReviewToggle = (id, reviewType) => {
  return {
    type: LIKE_REVIEW_TOGGLE,
    id,
    reviewType,
  };
};

export const likeReviewSuccess = (id, value) => {
  return {
    type: LIKE_REVIEW_SUCCESS,
    id,
    value,
  };
};

export const likeReviewFailed = () => {
  return {
    type: LIKE_REVIEW_FAILED,
  };
};

export const saveReviewDraft = draft => {
  return {
    type: SAVE_REVIEW_DRAFT,
    draft,
  };
};

export default {
  editReview,
  createReview,
  deleteReview,

  openReviewDialog,
  closeReviewDialog,

  reportReview,
  reportReviewSuccess,
  reportReviewFailed,
};
